import { render, staticRenderFns } from "./product-review-head.vue?vue&type=template&id=00c66048&"
import script from "./product-review-head.vue?vue&type=script&lang=js&"
export * from "./product-review-head.vue?vue&type=script&lang=js&"
import style0 from "./product-review-head.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00c66048')) {
      api.createRecord('00c66048', component.options)
    } else {
      api.reload('00c66048', component.options)
    }
    module.hot.accept("./product-review-head.vue?vue&type=template&id=00c66048&", function () {
      api.rerender('00c66048', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/product/product-review-head.vue"
export default component.exports